import { render, staticRenderFns } from "./mode19.vue?vue&type=template&id=55f54620&scoped=true"
import script from "./mode19.vue?vue&type=script&lang=js"
export * from "./mode19.vue?vue&type=script&lang=js"
import style0 from "./mode19.vue?vue&type=style&index=0&id=55f54620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f54620",
  null
  
)

export default component.exports